import { renderJSXElementToString } from '@pendwa/common-browser/core/ssr/renderJSXElementToString.js';
import { isPrerendering } from '@pendwa/common-browser/utils/isPrerendering.js';
import { APP_CONSTANTS } from '@pendwa/common/utils/constants.js';
import { createRoot } from 'react-dom/client';
import { apolloClient } from '../core/apollo/index.js';
import { App } from './App.js';

const root_element = document.querySelector('#root');

async function makePage() {
  if (root_element) {
    if (isPrerendering()) {
      const { html_content, apollo_state } = await renderJSXElementToString(<App />, apolloClient);

      root_element.innerHTML = html_content;

      // add the script with apollo state
      const string_state = JSON.stringify(apollo_state).replace(/</g, '\\u003c');
      const js_string = `window["${APP_CONSTANTS.APOLLO_STATE_META_NAME}"] = ${string_state};`;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = js_string;
      // eslint-disable-next-line unicorn/prefer-dom-node-append
      document.head.appendChild(script);
    } else {
      const root = createRoot(root_element);
      root.render(<App />);
    }
  } else {
    throw new Error('root element not found');
  }
}

makePage();
